module.exports = __webpack_public_path__ + "static/media/text.7e5d57bf.png";